/**
 * PATH: apps/qa/src/components/AreaCardPhotoSources.tsx
 * FILE_ID: QA-HUB-AREA-PHOTO-SOURCES-001
 * PURPOSE: QDrive + HEIC photo source for AreaCard without inlining into it.
 */
import { QA_PHOTO_ACCEPT, QaPhotoSourceMenu } from '@quotech/job-hub/jobs/qa'
import { listQaQDriveFiles } from '@/lib/qaQDriveList'

export { QA_PHOTO_ACCEPT }

export function AreaCardPhotoSources({
  busy,
  onPickFile,
  onPickAsset,
}: {
  busy?: boolean
  onPickFile: (file: File) => void | Promise<void>
  onPickAsset: (assetId: string, filename?: string) => void | Promise<void>
}) {
  return (
    <QaPhotoSourceMenu
      busy={busy}
      listQDriveFiles={listQaQDriveFiles}
      onPickFile={onPickFile}
      onPickAsset={onPickAsset}
    />
  )
}
